import { SearchRouteService } from './../../../Services/searchroute.service';
import { SeoService } from './../../../Services/seo.service';
import { CookieService } from 'ngx-cookie-service';
import { GeolocationService } from './../../../Services/geolocation.service';
import { MainService } from 'src/app/Services/service.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SearchSmallComponent } from './../../../Adv/search-small/search-small.component';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SearchComponent extends SearchSmallComponent{

  selectOpenChange(isOpen,matSelect){
    const backdropOverlay = matSelect.overlayDir._overlay._overlayContainer._containerElement;
    const backdropOverlayHeight = backdropOverlay.offsetHeight;
    const optionsLength = matSelect.options.length
    
    if(isOpen){

      if(optionsLength < 2){
        backdropOverlay.classList.add("emptyOptions");
      }else{
        backdropOverlay.classList.remove("emptyOptions");
      }

      backdropOverlay.classList.add("customBackdropOverlay");
      if(backdropOverlayHeight<250){
        backdropOverlay.classList.add("customBackdropOverlay250");
      }else if(backdropOverlayHeight<350){
        backdropOverlay.classList.add("customBackdropOverlay350");
      }else if(backdropOverlayHeight<450){
        backdropOverlay.classList.add("customBackdropOverlay450");
      }
    }
  }

  get keywords(): any { return this.advSearchForm.get('keywords') };
  get zipCode(): any { return this.advSearchForm.get('zipCode') };

  constructor(router: Router, fb: FormBuilder, service: MainService, geolocationService: GeolocationService, cookieService: CookieService, seo: SeoService, searchRouteService: SearchRouteService) {
    super(router, fb, service, geolocationService, cookieService, seo, searchRouteService);
    service.pageName = "Search";
  }

  getRouterUrl(){ return super.getRouter().url };

  resetKeywords():void{
    this.advSearchForm.patchValue({keywords: ''});
  }
  resetZip():void{
    this.advSearchForm.patchValue({zipCode: ''});
  }
}